import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  root: {
    padding: '0 20px',
    margin: '0 auto',
  },
});
